import { useEffect, useMemo, type ReactNode } from "react";
import { ApolloProvider } from "@apollo/client";
import { createApolloClient, setGraphQLErrorHandler } from "@/services/graphql";
import { useNotificationContext } from "./NotificationProvider";

export function GraphQLProvider({ children }: { children: ReactNode }) {
  const { notify } = useNotificationContext();
  const client = useMemo(() => createApolloClient(), []);

  useEffect(() => {
    setGraphQLErrorHandler((message) => notify(message, "error"));
    return () => setGraphQLErrorHandler(null);
  }, [notify]);

  return <ApolloProvider client={client}>{children}</ApolloProvider>;
}
